module.exports = __webpack_public_path__ + "static/media/copy-icon.632d7d10.svg";